import { render, staticRenderFns } from "./salesCommissionAction.vue?vue&type=template&id=710a1386&scoped=true"
import script from "./salesCommissionAction.vue?vue&type=script&lang=js"
export * from "./salesCommissionAction.vue?vue&type=script&lang=js"
import style0 from "./salesCommissionAction.vue?vue&type=style&index=0&id=710a1386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710a1386",
  null
  
)

export default component.exports